import { Fragment, useState } from "react";
import ContentCard from "../../ui/cards/ContentCard";
import FilingDetailsModal from "./FilingDetailsModal";

function FilingResume({ filing, isConfirmed = false, onConfirmChange, hideConfirmation = false }) {
  /**
   * This component will display a simplified filing resume, mainly used in the checkout page.
   * @param {boolean} hideConfirmation - If true, hides the confirmation checkbox (used for demo filings)
   */
  const services = filing.tax_service.services;
  const price = filing.tax_situation.filing_price;
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  // Helper function to get service display name
  const getServiceName = (service) => {
    switch (service) {
      case "PTF":
        return "Personal Filing";
      case "BTF":
        return "Business Filing";
      default:
        return service;
    }
  };

  return (
    <Fragment>
      <div>
        <ContentCard>
          <h3>Filing Summary</h3>

          {/* Services */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "4px",
              alignItems: "flex-start",
            }}
          >
            <span style={{ fontWeight: "500", color: "#40464b" }}>Service:</span>
            <span style={{ color: "#666", fontWeight: "300" }}>
              {services.map((service, index) => (
                <span key={service} style={{ color: "#666b6f" }}>
                  {getServiceName(service)}
                  {index < services.length - 1 && ", "}
                </span>
              ))}
            </span>
          </div>

          {/* Price */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "4px",
              alignItems: "flex-start",
            }}
          >
            <span style={{ fontWeight: "500", color: "#40464b" }}>Price:</span>
            <span style={{ color: "#666b6f", fontWeight: "300" }}>${price}</span>
          </div>

          {/* Audit Protection */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "4px",
              alignItems: "flex-start",
            }}
          >
            <span style={{ fontWeight: "500", color: "#40464b" }}>Audit Protection:</span>
            <span style={{ color: "#666b6f", fontWeight: "300" }}>
              {filing.audit_protection ? "Yes" : "No"}
            </span>
          </div>

          {/* View Details Button */}
          <div style={{ marginTop: "8px" }}>
            <button
              type="button"
              className="cta-button secondary"
              onClick={() => setIsDetailsModalOpen(true)}
              style={{ width: "100%" }}
            >
              Confirm Filing Details
            </button>
          </div>

          {/* Confirmation Checkbox - hidden for demo filings */}
          {!hideConfirmation && (
            <div 
              style={{ 
                marginTop: "12px",
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
              }}
            >
              <input
                type="checkbox"
                id="confirm-filing-details"
                className="visible-checkbox"
                checked={isConfirmed}
                onChange={(e) => onConfirmChange?.(e.target.checked)}
                style={{ marginTop: "4px", flexShrink: 0 }}
              />
              <label
                htmlFor="confirm-filing-details"
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#666b6f",
                  lineHeight: "1.5",
                }}
              >
                I Confirm Filing Details and allow documents regarding with filing 
                process be shared with the matched expert only for filing return concern.
              </label>
            </div>
          )}
        </ContentCard>
      </div>

      {/* Filing Details Modal */}
      {isDetailsModalOpen && (
        <FilingDetailsModal
          filing={filing}
          onClose={() => setIsDetailsModalOpen(false)}
        />
      )}
    </Fragment>
  );
}

export default FilingResume;
